import { IconProps } from "@/src/sb/business-layer/types"

const Briefcase = (props: IconProps) => (
  <svg
    width={props.width ?? props.size ?? 16}
    height={props.height ?? props.size ?? 16}
    viewBox="0 0 28 28"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.625 7.875H21V5.25C21 4.2835 20.2165 3.5 19.25 3.5H8.75C7.7835 3.5 7 4.2835 7 5.25V7.875H4.375C2.92525 7.875 1.75 9.05025 1.75 10.5V22.75C1.75 23.7165 2.5335 24.5 3.5 24.5H24.5C25.4665 24.5 26.25 23.7165 26.25 22.75V10.5C26.25 9.05025 25.0747 7.875 23.625 7.875ZM8.75 5.25H19.25V7.875H8.75V5.25ZM24.5 22.75H3.5V14.875H10.5V19.25H17.5V14.875H24.5V22.75ZM12.25 14.875H15.75V17.5H12.25V14.875ZM3.5 13.125V10.5C3.5 10.0168 3.89175 9.625 4.375 9.625H23.625C24.1082 9.625 24.5 10.0168 24.5 10.5V13.125H3.5Z"
      fill="currentColor"
    />
  </svg>
)

export default Briefcase
